import BranchCustomersInBranchPerHourReport from "../../../components/branches/reports/daily/BranchNumberOfCustomersInHour";
import DailyGeneratedReportPage from "../../../components/reports/DailyGeneratedReportPage";
import { REPORT_TYPE_IDS } from "../../../store/constants";
import { CUSTOMERS_IN_BRANCH_COLUMN_DEFINITIONS } from "../../../store/renderConfig";

const BranchCustomersInBranchPerHour = ({
  showFilterForm = true,
  reportIndex = 1,
  showTitle = 1,
}) => (
  <DailyGeneratedReportPage
    branchScoped={true}
    reportTypeId={REPORT_TYPE_IDS.daily_branch_customers_in_branch_per_hour}
    title="Customers In Branch Per Hour"
    helmetTitle="Daily Branch Customers In Branch Per Hour"
    descriptionKey="BranchesCustomersInBranchPerHour"
    columnDefinitions={CUSTOMERS_IN_BRANCH_COLUMN_DEFINITIONS}
    defaultSortColumn="total"
    showFilterForm={showFilterForm}
    showTitle={showTitle}
  >
    {({ data, renderConfig, onRenderConfigChange }) => (
      <BranchCustomersInBranchPerHourReport
        data={data}
        reportIndex={reportIndex}
        renderConfig={renderConfig}
        onRenderConfigChange={onRenderConfigChange}
      />
    )}
  </DailyGeneratedReportPage>
);

export default BranchCustomersInBranchPerHour;
